import {SlArrowDown} from 'react-icons/sl'
export default function Faq1() {
  return (
    <div className="faq">

    <h3>سنقوم هنا بإدراج 10 أسئلة ترغبون جميعًا في طرحها حول الاختبار النظري والإجابة عليها بإيجاز.</h3>
     
     {/* Qusetions  */}
     
     
      <div className="question">
        <p><strong>ما هو العمر المناسب لاجتياز الاختبار النظري؟</strong> </p>
        <p>كان هناك تغيير في القانون منذ وقت ليس ببعيد ، وتم تقديم العمر الذي يمكنك فيه إجراء الاختبار وهو حاليًا 16 و 9 أشهر. إذا نجحت في الاختبار ، تحصل على تصريح للقيادة برفقة. ينطبق التزام المرافقة فقط على السائقين الجدد الذين تقل أعمارهم عن 24 عامًا (راجع المقالة على موقع 1sTest على الويب حول موضوع قانون رخصة القيادة المتخرجين). لم يتغير العمر الذي يمكنك فيه أداء الاختبار النظري ويبقى 16 عامًا ونصف.</p>
      </div>

      <div className="question">
        <p><strong> أين الامتحانات؟</strong></p>
        <p>تجري وزارة النقل اختبارات نظرية من خلال مشغلين خاصين في مراكز الاختبار النظري. يمكنك العثور على تفاصيل حول موقع مراكز الاختبارات وساعات العمل عبر الإنترنت - على موقع الاختبارات النظرية. على موقع الويب ، يمكنك التسجيل للاختبار النظري ويمكنك أيضًا الدفع عن طريق بطاقة الائتمان ، أو يمكنك أيضًا الدفع عبر الهاتف أو نقدًا في مركز الاختبار النظري.</p>
      </div>

      <div className="question">
        <p><strong>كيف تسجل؟</strong></p>
        <p> على الموقع الإلكتروني ، يمكنك حجز موعد للاختبار النظري والدفع مقدمًا. يمكنك أيضًا الحضور للاختبار والدفع على الفور. يوصى بالوصول إلى مركز الاختبار قبل الاختبار بخمس عشرة دقيقة.</p>
      </div>

      <div className="question">
        <p><strong> ما هي تكلفة ذلك؟</strong></p>
        <p>اعتبارًا من نهاية عام 2023 ، كان سعر الاختبار النظري 68 شيكل. قد تكون هناك تغييرات طفيفة في السعر من وقت لآخر ، لذلك يجب عليك البقاء على اطلاع دائم على موقع الاختبار النظري أو موقع وزارة السير.</p>
      </div>

      <div className="question">
        <p><strong>كم مرة يسمح للاختبار؟</strong></p>
        <p>يُسمح لك بإجراء الاختبارات النظرية عدة مرات كما تريد وتحتاج إلى اجتياز الاختبار. ليست هناك حاجة لفترة تهدئة بين اختبار نظري وآخر ، ولكن يمكنك - إذا أردت - إجراء الاختبار يومًا بعد يوم. </p>
      </div>
      <div className="question">
        <p><strong>ما هي مدة صلاحية الاختبار النظري؟</strong></p>
        <p> الاختبار النظري صالح لمدة عامين. إذا لم يحصل الطالب على رخصة قيادة خلال هذا الوقت ، فسيتعين عليه إعادة الاختبار النظري والفحوصات الطبية.</p>
      </div>
      <div className="question">
        <p><strong>كيف يتم تنظيم الاختبار النظري؟</strong></p>
        <p> يحتوي الاختبار النظري على 30 سؤالاً متعدد الخيارات (سؤال "أمريكي") مأخوذة من مجموعة من 1800 سؤال. يوجد أسفل كل سؤال أربع إجابات محتملة: ثلاث إجابات خاطئة أو صحيحة جزئيًا وواحدة صحيحة تمامًا. يجب على الممتحن تحديد الإجابة الصحيحة. </p>
      </div>
      <div className="question">
        <p><strong>ما هي الاختبارات؟</strong></p>
        <p>في الاختبار النظري ، يُطلب من الممتحن إثبات معرفته بالموضوعات التالية: </p>
        <ol>
          <li>قوانين المرور</li>
          <li>التعرف على إشارات المرور وأشكالها ومعانيها للسائق</li>
          <li>قواعد السلوك على الطريق</li>
          <li>معرفة طريقة عمل السيارة - اجزاء المركبة وملحقاتها واستخدامها وصيانتها بشكل دوري</li>
        </ol>
        <p className="text-color-primary-light"> لذلك كن حذرًا عند دراسة النظرية حول هذه الموضوعات.</p>
      </div>
      <div className="question">
        <p><strong>ما هي الدرجة التي تحتاجها لاجتياز الاختبار النظري؟</strong></p>
        <p>لاجتياز الاختبار النظري ، يجب أن تجيب على الأقل 26 سؤالاً بشكل صحيح. خمسة أخطاء أو أكثر ستكسب درجة رسوب! وبالتالي ، من أجل اجتياز الاختبار النظري ، يجب أن تحصل على درجة 86.6٪ أو أعلى - وهذا كثير جدًا! </p>
      </div>
      <div className="question">
        <p><strong>هل من الممكن استئناف الاختبار النظري؟</strong></p>
        <p> يتلقى الممتحنون نتائج الاختبار في مكان الاختبار ويومه. يتم إرجاع النموذج الأصلي للممتحن مع النتائج ، مما يتيح له معرفة الأخطاء التي ارتكبها وما أجاب عليه بشكل صحيح. يمكن للممتحن استئناف الدرجة التي حصل عليها في الاختبار النظري ، لكن الاستئناف لا يتم في مراكز الاختبار النظري ، ولكن يتم إجراؤه فقط في مكتب الترخيص في نفس المنطقة التي تم فيها إجراء الاختبار.</p>
      </div>

    </div>
  )
}
